/**
 * Changes the input field of the form
 *
 * @return {object}    An action object with a type of REQUEST_TOKEN
 */
import {
  LOAD_CLAIM_LIST,
  LOAD_CLAIM_LIST_SUCCESS,
  LOAD_CLAIM_LIST_ERROR,
  CREATE_NEW_CLAIM,
  UPDATE_SELECTED_CLAIM_ID,
  LOAD_CLAIM,
  LOAD_CLAIM_SUCCESS,
  PRE_LOAD_CLAIM,
  CREATE_NEW_CLAIM_SUCCESS,
  LOAD_CLAIM_TYPE,
  LOAD_CLAIM_TYPE_SUCCESS,
  LOADING_BUTTON,
  LOAD_CLAIM_FROM_SUMMARY,
  UPDATE_SELECTED_CLAIM_NUMBER,
  UPLOAD_CLAIM_SUMMARY,
  DOWNLOAD_SUMMARY,
} from './constants';

export function loadClaimList() {
  return {
    type: LOAD_CLAIM_LIST,
  };
}

export function loadClaimListSuccess(claims) {
  return {
    type: LOAD_CLAIM_LIST_SUCCESS,
    claims,
  };
}

export function updateSelectedClaimId(claimId) {
  return {
    type: UPDATE_SELECTED_CLAIM_ID,
    claimId,
  };
}

export function updateSelectedClaimNumber(claimNumber) {
  return {
    type: UPDATE_SELECTED_CLAIM_NUMBER,
    claimNumber,
  };
}

export function createNewClaimSuccess() {
  return {
    type: CREATE_NEW_CLAIM_SUCCESS,
  };
}

export function requestClaimsError(err) {
  return {
    type: LOAD_CLAIM_LIST_ERROR,
    error: err,
  };
}

export function requestNewClaimId() {
  return {
    type: CREATE_NEW_CLAIM,
  };
}

export function loadClaim() {
  return {
    type: LOAD_CLAIM,
  };
}

export function loadClaimSuccess() {
  return {
    type: LOAD_CLAIM_SUCCESS,
  };
}

export function preLoadClaim(submitted) {
  return {
    type: PRE_LOAD_CLAIM,
    submitted,
  };
}

export function loadClaimType() {
  return {
    type: LOAD_CLAIM_TYPE,
  };
}

export function loadClaimTypeSuccess(claimTypes) {
  return {
    type: LOAD_CLAIM_TYPE_SUCCESS,
    claimTypes,
  };
}

export function loading(status) {
  return {
    type: LOADING_BUTTON,
    status,
  };
}

export function loadClaimFromSummary() {
  return {
    type: LOAD_CLAIM_FROM_SUMMARY,
  };
}

export function uploadClaimSummary(blob) {
  return {
    type: UPLOAD_CLAIM_SUMMARY,
    blob,
  };
}

export function downLoadSummary(cb) {
  return {
    type: DOWNLOAD_SUMMARY,
    cb,
  };
}



// WEBPACK FOOTER //
// ./app/containers/ClaimList/actions.js